import type { NuxtApp } from '#app'

import UploadApi from '@/services/api/upload.api'
import CategoryApi from '@/services/api/category.api'
import UserApi from '@/services/api/user.api'
import AuthApi from '@/services/api/auth.api'
import ArtistApi from '@/services/api/artist.api'
import VerificationApi from '@/services/api/verification.api'

class ApiService {
  uploadApi: UploadApi
  categoryApi: CategoryApi
  userApi: UserApi
  authApi: AuthApi
  artistApi: ArtistApi
  verificationApi: VerificationApi

  constructor(app: NuxtApp) {
    this.uploadApi = new UploadApi(app)
    this.categoryApi = new CategoryApi(app)
    this.userApi = new UserApi(app)
    this.authApi = new AuthApi(app)
    this.artistApi = new ArtistApi(app)
    this.verificationApi = new VerificationApi(app)
  }
}

export default ApiService
